// extracted by mini-css-extract-plugin
module.exports = {"btn-documents":"button-docs_btn-documents__2CmBD","no-background":"button-docs_no-background__16Tlx","sub":"button-docs_sub__2yDN5"};